<template>
  <div id="RegisterUser" :class="getModalClass">
    <b-loading :is-full-page="true" :active.sync="isLoading" ></b-loading>
    <header class="modal-card-head ">
      <p class="modal-card-title">
        <span v-if = "!registrationCompleted">Registro</span>
        <span v-else>¡Registro completo!</span>
      </p>
    </header>

    <section v-if="registrationLoading" class="modal-card-body login-container">
      loading...
    </section>

    <section v-else-if="!registrationCompleted" id="register-container" class="modal-card-body login-container">
        <div class="register-view" >
          <b-field label="E-mail"
          :type="email_type"
          :message="email_message">
              <b-input
                  type="email"
                   id="email"
                   ref="emailField"
                   v-model="inputs.email"
                  placeholder="Tu email"
                  required>
              </b-input>
          </b-field>

          <b-field label="Contraseña"
          :type="pwd_type"
          :message="pwd_message">
            <b-input
              type="password"
              ref="passwordField"
              v-model="inputs.password1"
              id="password"
              placeholder="contraseña"
              expanded password-reveal
              required>
            </b-input>
          </b-field>

          <b-field label="Confirmar contraseña">
            <b-input
              type="password"
              v-model="inputs.password2"
              id="password2"
              placeholder="confirmar contraseña"
              expanded password-reveal
              required>
            </b-input>
          </b-field>
          <div id="terms-container">
          <div class="field field-term" :type="type_globalTerm1">
            <b-checkbox type="is-success" @input="checkGlobalTerm1" required ref="checkboxGlobalterm1" v-model="terms['globalTerm1']"  >
            </b-checkbox>
            <a class="view-terms" :class="type_globalTerm1" @click="viewTerms('globalTerm1')">Acepto las condiciones de uso de la plataforma Programalaplaza</a>
          </div>

          <div  v-if="showTermsError" class="field error-msg notification is-danger" >
            <span> {{checkboxErrorMsg}} </span>
          </div>

          <div class="field field-term"  :type="type_globalTerm2">
            <b-checkbox type="is-success" @input="checkGlobalTerm2" required ref="checkboxGlobalterm2" v-model="terms['globalTerm2']"></b-checkbox>
            <a class="view-terms" :class="type_globalTerm2" @click="viewTerms('globalTerm2')"> Acepto recibir emails relacionados con ProgramaLaPlaza y sus convocatorias</a>
          </div>
        </div>

        <div>
          <button class="btn btn-bg-colored is-primary is-fullwidth" @click="registerClick" v-if="!registrationCompleted">Registrarse</button>
        </div>

      </div>
        <div class="notification is-danger" style="margin-top:1em!important;" v-show="registrationError && non_field_error.length>0">
          Ha ocurrido un error creando el usuario <br/>
          {{non_field_error}}
        </div>
        <div class="aux-links">
          <span> <a  v-on:click="showLogin"> Ya tengo cuenta, entrar </a> </span>

          <!--<router-link :to="{ name: 'resetPassword' }">Resetear contraseña</router-link>-->

        </div>

    </section>

    <section v-else class="modal-card-body login-container">
      <div class="registration-complete">
        <section class="">
          <h2> Por favor no olvides verificar tu dirección de email siguiendo el enlace que te hemos enviado</h2>
        </section>
      <section class="">
        <p>
          Si eres <strong> profesor </strong> ahora puedes ir a <router-link :to="{ name: 'User'}" v-on:click.native="close">  tu página de perfil </router-link> para crear una clase para tus alumnos.
        </p>
        <p>
          Si eres <strong> participante </strong> puedes <router-link :to="{ name: 'Editor.create'}" v-on:click.native="close"> Crear ya tu nuevo proyecto </router-link> o <router-link :to="{ name: 'User'}" >  agregarte a una clase</router-link>.
        </p>
      </section>
      </div>

    </section>

    <footer v-if="isModal" class="modal-card-foot">
      <button class="btn" type="button" @click="close">Cerrar</button>
    </footer>

    <b-modal :active.sync="isComponentModalActive" has-modal-card>
      <div class="modal-card">
         <section class="modal-card-body">
           <div id="terms-text-container">
            <div class="terms-text-outer">
              <div class="terms-text-inner" v-html="getText"> </div>
            </div>
          </div>
         </section>
         <footer class="modal-card-foot">
           <button class="button is-success" v-on:click="accept">Aceptar</button>
           <button class="button" v-on:click="closeModal">Cerrar</button>
         </footer>
       </div>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  name: 'Register',
  props: {
    isModal: false
  },
  data () {
    return {
      inputs: {
        password1: '',
        password2: '',
        email: ''
      },
      email_type: '',
      email_message: '',
      pwd_type: '',
      pwd_message: '',
      non_field_error: '',
      type_globalTerm1: '',
      type_globalTerm2: '',
      isComponentModalActive: false,
      terms: {'globalTerm1': false, 'globalTerm2': false},
      currentTermText: '',
      currentTermInView: '',
      checkboxErrorMsg: 'Tienes que aceptar los términos y condiciones de uso',
      triedToSubmit: false,
      textoTerms: {'globalTerm1': '', 'globalTerm2': ''},
      isLoading: false
    }
  },
  computed: {
    ...mapState('signup', [
      'registrationCompleted',
      'registrationError',
      'registrationLoading',
      'errors'
    ]),
    getModalClass () {
      if (this.isModal) return 'modal-card'
      else return ''
    },
    getText () {
      return this.currentTermText
    },
    showTermsError () {
      if (this.triedToSubmit === false) return false
      return !(this.terms['globalTerm1'])
    }
  },

  methods: {
    registerClick () {
      this.triedToSubmit = true
      if (this.ifFormValid()) {
        this.isLoading = true
        this.createAccount(this.inputs)
          .then(() => {
            this.$store.dispatch('auth/login', {'email': this.inputs.email, 'password': this.inputs.password1})
              .then(() => {
                this.$store.dispatch('user/setMyTerms', this.terms.globalTerm2)
              })
          })
          .catch((error) => {
            console.log(error.response.data)
            if (error.response.data.password1 !== undefined) {
              this.pwd_type = 'is-danger'
              this.pwd_message = ''
              error.response.data.password1.forEach((err) => { this.pwd_message += err })
            } else {
              this.pwd_type = ''
              this.pwd_message = ''
            }
            // email errors
            if (error.response.data.email !== undefined) {
              this.email_type = 'is-danger'
              this.email_message = ''
              error.response.data.email.forEach((err) => { this.email_message += err })
            } else {
              this.email_type = ''
              this.email_message = ''
            }

            if (error.response.data.non_field_errors !== undefined) {
              this.non_field_error = error.response.data.non_field_errors[0]
            } else {
              this.non_field_error = ''
            }
          })
          .finally(() => { this.isLoading = false })
      }
    },
    showLogin: function () {
      if (this.isModal) {
        this.$store.commit('setEditorConfigProperty', {'isShowingLogin': true})
        this.$store.commit('setEditorConfigProperty', {'isShowingRegister': false})
        // this.$parent.close()
      } else {
        this.$emit('showlogin')
      }
    },
    ...mapActions('signup', [
      'createAccount',
      'clearRegistrationStatus'
    ]),
    close: function () {
      this.$store.commit('setEditorConfigProperty', {'isShowingRegister': false})
    },
    saveAndClose: function () {
      /* this.$store.commit('setProjectTitle', this.title)
      this.$store.commit('setProjectDescription', this.description)
      this.hideSetings()
      this.$emit('save') */
    },
    ifFormValid () {
      var isValid = (this.checkGlobalTerm1() && this.$refs.emailField.checkHtml5Validity() && this.$refs.passwordField.checkHtml5Validity())
      return (isValid)
    },
    checkGlobalTerm1 () {
      if (this.terms['globalTerm1'] === false) {
        this.type_globalTerm1 = 'is-danger'
        return false
      } else {
        this.type_globalTerm1 = 'is-success'
        return true
      }
    },
    checkGlobalTerm2 () {
      if (this.terms['globalTerm2'] === false) {
        this.type_globalTerm2 = 'is-danger'
        return false
      } else {
        this.type_globalTerm2 = 'is-success'
        return true
      }
    },
    viewTerms (kindOfTerm) {
      this.currentTermText = this.textoTerms[kindOfTerm]
      this.currentTermInView = kindOfTerm
      this.isComponentModalActive = true
    },
    closeModal () {
      this.isComponentModalActive = false
    },
    accept () {
      this.terms[this.currentTermInView] = true
      this.closeModal()
    },
    loadTerms () {
      this.axios.get('./static/terminos_mlab.html').then((response) => {
        console.log(response)
        this.textoTerms.globalTerm1 = response.data
      })
      this.axios.get('./static/terminos_contacto.html').then((response) => {
        this.textoTerms.globalTerm2 = response.data
      })
    }
  },
  created () {
    this.loadTerms()
  }
}

</script>

<style lang = "less" scoped>
@import (reference) "../../assets/styles/main.less";

h2 {
  margin-bottom: 2em;
}

#terms-container {
  padding: 20px 0px;
}

a.view-terms.is-danger {
  color: @accentColorSecondary;
}

</style>



// WEBPACK FOOTER //
// src/components/Login/RegisterUser.vue